import * as React from "react";
import BaseLayout from "../../components/BaseLayout";
import ClientsList from "../../features/ClientsList";

function ClientPage() {
  return (
    <BaseLayout>
      <ClientsList />
    </BaseLayout>
  );
}

export default ClientPage;
